export default __webpack_public_path__ + "static/9-4b9d3ac6d5a3c01fa5cebef70d9997fd.png";